export const uniSocketMixin = {
    data() {
        return {
            socket: null,
            isConnect: false,
            reconnectCount: 0,
            maxreconnectCount: 10,
            reconnectTimer: null,
            isHandClose: false,
            heartbeatInterval: null,
            sendArr: [],
            resetSocketTimer: null,
            resetSocketCount: 0,
        }
    },
    methods: {
        connect() {
            this.socket = new WebSocket(this.url);
            this.socket.onopen = () => { this.socketOpen(); };
            this.socket.onclose = () => { this.socketClose(); };
            this.socket.onerror = () => { this.socketError(); };
            this.socket.onmessage = (meg) => {
                let data = JSON.parse(meg.data);
                if (data.arg && data.data) {
                    if (data.arg.channel == 'books') {
                        this.resetSocketCount = 0
                    }
                }
                this.socketMessage(JSON.parse(meg.data));
            };
        },
        /**
     * 连接成功
     */
        socketOpen() {
            this.isConnect = true;
            this.reconnectCount = 0;
            this.reconnectTimer && clearTimeout(this.reconnectTimer);
            this.isHandClose = false;
            this.heartbeat();
            this.sendArr.length && this.sendArr.forEach(item => {
                this.send(item);
            })
            this.sendArr = [];
            if (!this.resetHeartbeat) return;
            this.resetSocketTimer = setInterval(() => {
                this.resetSocketCount += 1
                console.log(this.resetSocketCount, '10');
                if (this.resetSocketCount >= 10) {
                    this.socketClear();
                    setTimeout(() => {
                        this.connect();
                        this.subscription();
                    }, 3000);
                }
            }, 1000);

        },
        /**
         * 连接关闭
         */
        socketClose() {
            this.isConnect = false;
            this.clearHeartbeat();
            this.clearResetTimer();
            console.log('连接错误1');
            this.reconnect();
        },
        /**
          * 连接错误
         */
        socketError() {
            console.log('连接错误2');
            // this.clearResetTimer();
        },
        /**
          * 接收消息
         */
        socketMessage(meg) {
            this.onWebSocketMessage(meg);
        },
        /**
        * 自动重连
        */
        reconnect() {
            if (this.isHandClose) return;
            if (this.socket) return;
            if (this.reconnectCount < this.maxReconnectCount) {
                this.reconnectCount++;
                this.reconnectTimer = setTimeout(() => {
                    this.connect();//连接
                }, 3000);
            } else {
            }
        },
        /**
        * 开启心跳
        */
        heartbeat() {
            this.clearHeartbeat();
            this.heartbeatInterval = setInterval(() => {
                this.send({ type: 'ping', "payLoad": { "ts": new Date().getTime() } });
            }, 15000)
        },
        /**
         * 关闭心跳
         */
        clearHeartbeat() {
            this.heartbeatInterval && clearInterval(this.heartbeatInterval);
        },
        /**
        * 发送消息
        */
        send(data) {
            if (!this.isConnect && data.type !== "ping") {
                const hasEqualItem = this.sendArr.length && this.sendArr.some(item => JSON.stringify(item) == JSON.stringify(data));
                if (!hasEqualItem) {
                    this.sendArr.push(data);
                }
                return;
            }
            this.socket.send(JSON.stringify(data));
        },

        /**
         * 关闭10秒内没收到books的消息重新连接socket的定时器
         */
        clearResetTimer() {
            console.log('连接错误');
            if (!this.resetSocketTimer) return;
            this.resetSocketCount = 0;
            clearInterval(this.resetSocketTimer);
        },
        /**
         * 清空socket
         */
        socketClear() {
            this.isHandClose = true;
            this.resetSocketTimer && clearTimeout(this.resetSocketTimer);
            this.reconnectTimer && clearTimeout(this.reconnectTimer);
            if (this.socket && "close" in this.socket) {
                this.socket.close();
            }
        },

    }
}


// WEBPACK FOOTER //
// ./src/components/uniSocketMixin.js